import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import React from 'react'

export type InvitedUser = {
  username: string
}

export function GithubUserRow({
  user,
  RightElement,
}: {
  user: InvitedUser
  RightElement: React.ReactNode
}) {
  return (
    <div className={`flex items-center justify-between p-2 bg-secondary rounded-md `}>
      <div className="flex items-center space-x-2">
        <Avatar>
          <AvatarImage
            src={`https://github.com/${user.username}.png?size=100`}
            alt={user.username}
          />
          <AvatarFallback>{user.username[0].toUpperCase()}</AvatarFallback>
        </Avatar>
        <span>{user.username}</span>
      </div>
      {RightElement}
    </div>
  )
}
